var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.3V3.42701C9 3.25744 9.19777 3.16481 9.32804 3.27336L11.5756 5.14636C11.7193 5.26611 11.6346 5.5 11.4476 5.5H9.2C9.08954 5.5 9 5.41046 9 5.3Z",
    fill: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2998 3C8.41026 3 8.5 3.08974 8.5 3.2002V5.7998C8.5 5.91026 8.58974 6 8.7002 6H11.7998C11.9103 6 12 6.08974 12 6.2002V12.5C12 12.7761 11.7761 13 11.5 13H4.5C4.22386 13 4 12.7761 4 12.5V3.5C4 3.22386 4.22386 3 4.5 3H8.2998ZM10.0723 7.45508C9.8402 7.24244 9.48027 7.25821 9.26758 7.49023L7.5918 9.31738L6.69922 8.49414C6.46796 8.28086 6.10704 8.29531 5.89355 8.52637C5.68009 8.75762 5.69464 9.11849 5.92578 9.33203L7.23828 10.5439C7.34954 10.6466 7.49717 10.7006 7.64844 10.6943C7.79982 10.688 7.94254 10.6215 8.04492 10.5098L10.1074 8.25977C10.3201 8.0277 10.3043 7.66777 10.0723 7.45508Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormCompleted);
export default __webpack_public_path__ + "static/media/Form_completed.cea64499f42ca9b437a2db4c8efba7b3.svg";
export { ForwardRef as ReactComponent };